import { render, staticRenderFns } from "./UserCreateUpdate.vue?vue&type=template&id=19daafcd&scoped=true&"
import script from "./UserCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./UserCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateUpdate.vue?vue&type=style&index=0&id=19daafcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19daafcd",
  null
  
)

export default component.exports